<template>
    <div>
        <div class="bl bw2 absolute" :class="[color]" :style="{'bottom' : bottomPos + 'px', 'left' : left + '%', 'height' : height + 'px', 'transition' : (trans + 1) + 's', 'opacity' : .1}"></div>
        <div class="bl bw2 absolute" :class="[color]" :style="{'bottom' : bottomPos + 'px', 'left' : left + '%', 'height' : height + 'px', 'transition' : (trans + .5) + 's', 'opacity' : .3}"></div>
        <div class="bl bw2 absolute" :class="[color]" :style="{'bottom' : bottomPos + 'px', 'left' : left + '%', 'height' : height + 'px', 'transition' : trans + 's', 'opacity' : opacity}"></div>
    </div>
</template>

<script>
export default {
  props: ['start', 'left', 'bottom', 'color', 'trans'],
  data: function () {
    return {
      opacity: 0.5,
      height: 6,
      bottomPos: this.bottom
    }
  },
  methods: {
    rain: function () {
      this.bottomPos = Math.floor((Math.random() * 500) + 1)
      this.bottomPos *= Math.floor(Math.random() * 2) === 1 ? 1 : -1
    //   this.left = Math.floor((Math.random() * 100) + 1);
    //   this.height = Math.floor((Math.random() * 1.5) + 1);
    //   this.opacity = (Math.random() * .5);
    }
  },
  mounted: function () {
    setTimeout(function () { this.rain() }.bind(this), this.start)
    setInterval(function () { this.rain() }.bind(this), 12000)
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/rain-component.vue